module.exports = __webpack_public_path__ + "static/media/1_4.2cbaca13.png";